import { Voucher } from '../../../models/Voucher/Voucher.js';

class Vouchers {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  validate(voucherName, params) {
    const requestContext = this.apiClient.getRequestContext();
    return this.apiClient.post(`v1/vouchers/${voucherName}/validate`, {
      platform: requestContext === null || requestContext === void 0 ? void 0 : requestContext.platform,
      client_id: requestContext !== null && requestContext !== void 0 && requestContext.client_id ? requestContext === null || requestContext === void 0 ? void 0 : requestContext.client_id : params.client_id,
      service_id: params.serviceId
    }).then(response => Voucher.createFromResponse(response.data));
  }
  availability(params) {
    return this.apiClient.post('v1/vouchers/availability', params).then(response => response.data.map(service => ({
      serviceId: service.service_id,
      allowsVoucher: service.allows_voucher
    })));
  }
  validateShipments(voucher, shipmentsParams) {
    return this.apiClient.post('v1/vouchers/shipments/availability', {
      voucher,
      shipments: shipmentsParams.map(params => ({
        shipment_reference: params.packlinkReference,
        service_id: params.serviceId,
        base_price: params.totalBasePrice
      }))
    }).then(_ref => {
      let {
        data
      } = _ref;
      return data.map(Voucher.createFromResponse);
    });
  }
}

export { Vouchers };
//# sourceMappingURL=Vouchers.js.map
